export const QUALITY_LEVEL = {
    EXCELLENT: 100,
    GOOD: 99,
    HIGH: 79,
    NORMAL: 69,
    LOW: 54,
}
